import { MultiSelect } from 'primereact/multiselect'
import React from 'react'
import { useIntl } from 'react-intl'
import './multiSelectComp.scss'

const MultiSelectComp = ({
  value,
  onChange,
  options,
  optionLabel,
  optionValue,
  disabled,
}) => {
  const { formatMessage: msg } = useIntl()

  return (
    <MultiSelect
      filter
      name="carWashServices.others"
      value={value}
      onChange={(e) => onChange(e)}
      options={options}
      optionLabel={optionLabel}
      optionValue={optionValue}
      display="chip"
      placeholder={msg({ id: 'placeholder.select' })}
      disabled={disabled}
      pt={{
        item: ({ context }) => ({
          className: context.selected ? 'item-active' : undefined,
        }),
      }}
    />
  )
}

export default MultiSelectComp
